<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Afspraakbevestiging</h2>
<div modal-content class="modal-body">
    <p>U heeft een afspraak met {{ model.naam }} op {{ model.datum | dateFormat: "L" }} om {{ model.tijdstip }}u.</p>
</div>
<div class="modal-footer">
    <div class="btn-group btn-group--right">
        <button class="btn btn--primary" (click)="close()">Sluiten</button>
    </div>
</div>
